import { React, Component, Config } from 'utils';
import { Stand } from './stand';
import './pavilion.less';
import { Creators, App } from 'model';
import { SelectedPavilionStore } from 'model';

export class Pavilion extends Component {

	render() {
		let {data, history} = this.props;

		var css = ['pavilion'];
		var stands = null;
		var post = null;

		if(data) {

			css.push(data.slug);

			stands = data.stands.map(function(item) {
				return <Stand key={item.slug} data={item} history={history}/>
			});

			post = <div className="post">
				<div className="post-header"></div>
				<div className="post-footer"></div>
			</div>
		}

		return <div className={ css.join(' ') }>
			<div className="stands">
				{ post }
				{ stands }
			</div>
		</div>;

	}
}



// WEBPACK FOOTER //
// ./src/modules/components/pavilion.js